import {DashboardRow} from '@models/dashboard/dashboard-row';

export class DashboardConfiguration {
  id: number = -1;
  dashboardRowsMap: Map<string, DashboardRow> = new Map<string, DashboardRow>();
  name: string = '';
  placeholderImage: string = '';
}